if (!customElements.get('country-modal')) {
  customElements.define(
    'country-modal',
    class CountryModal extends ModalElement {
      constructor() {
        super();

        // Prevent popup on Shopify robot challenge page
        //
        // navigator.webdriver 是自動化瀏覽器（爬蟲、AI 購物代理、店鋪模擬工具）。
        // country-auto-switch.liquid 對它們直接 return，不會預先寫入
        // popoup_country_select_expiry，於是 isExpiry() 恆為真，這個彈窗必定在
        // delay 秒後彈出，再經 shouldLock 把 body 設成 overflow:hidden —— 一個真人
        // 永遠看不到的彈窗，卻把所有自動化訪客鎖在原地。這裡一併擋掉；真人路徑
        // 不經過這個分支，行為完全不變，防爬蟲的自動切換守衛也原樣保留。
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled || navigator.webdriver) {
          return;
        }

        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }

      get shouldLock() {
        return true;
      }

      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }

      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }

      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }

      get submited() {
        return this.querySelector('.alert') !== null;
      }

      init() {
        if (this.initialized) return;
        this.initialized = true;

        // Open modal if errors or success message exist
        if (this.submited) {
          this.load(1, true);
          return;
        }

        if (this.testMode || this.isExpiry()) {
          this.load(this.delay);
        }

        this.initLocalization();
      }

      initLocalization() {
        // const popupLanguageBtn = document.getElementById('popup-localization-language-btn');
        // popupLanguageBtn.addEventListener('click', (event) => {
        //   this.initLanguageDropdown();
        // });

        const popupCountryBtn = document.getElementById('popup-localization-country-btn');
        popupCountryBtn.addEventListener('click', (event) => {
          this.initCountryDropdown();
        });

        const popupShopBtn = document.getElementById('popup-localization-shop-btn');
        popupShopBtn.addEventListener('click', (event) => {
          this.changeLocalization();
        });
      }

      initLanguageDropdown() {
        const popupLanguageBtn = document.getElementById('popup-localization-language-btn');
        const popupLanguageText = document.getElementById('popup-localization-language-text');
        const iconSvg = popupLanguageBtn.querySelector('svg.icon');
        const iconPath = iconSvg?.querySelector('path');
        const popupLanguageDropdown = document.getElementById('popup-localization-language-dropdown');

        if (popupLanguageDropdown.style.visibility != "visible") {
          iconSvg.classList.remove(`icon-chevron-down`);
          iconSvg.classList.add(`icon-chevron-up`);
          iconPath.setAttribute('d', 'M6 15L12 9L18 15');

          let option = '<ul id="popup-localization-language-dropdown-menu" class="country-dropdown-nav">';

          window.availableLanguages.forEach(item => {
            option += '<li>';
            option += '<p data-value="' + item.iso_code + '"';
            if (popupLanguageText.dataset.value == item.iso_code) {
              option += 'class="active pointer-events-none"';
            }
            option += '>'
            option += item.endonym_name
            option += '</p>'
            option += '</li>';
          });
          option += '</ul>';

          popupLanguageDropdown.innerHTML = '';
          popupLanguageDropdown.innerHTML = option;
          const popupLanguageDropdownMenu = document.getElementById('popup-localization-language-dropdown-menu');
          popupLanguageDropdownMenu.addEventListener('click', (event) => {
            const option = event.target.closest('p[data-value]');
            if (!option) return;
            const value = option.dataset.value;
            const text = option.innerHTML;
            popupLanguageText.dataset.value = value;
            popupLanguageText.innerHTML = text;

            iconSvg.classList.remove(`icon-chevron-up`);
            iconSvg.classList.add(`icon-chevron-down`);
            iconPath.setAttribute('d', 'M6 9L12 15L18 9');
            popupLanguageDropdown.style.visibility = 'hidden';
          });

          popupLanguageDropdown.style.visibility = 'visible';
        } else {
          iconSvg.classList.remove(`icon-chevron-up`);
          iconSvg.classList.add(`icon-chevron-down`);
          iconPath.setAttribute('d', 'M6 9L12 15L18 9');
          popupLanguageDropdown.style.visibility = 'hidden';
        }
      }

      initCountryDropdown() {
        const popupCountryBtn = document.getElementById('popup-localization-country-btn');
        const popupCountryFlag = document.getElementById('popup-localization-country-flag');
        const popupCountryText = document.getElementById('popup-localization-country-text');
        const popupCountryDropdown = document.getElementById('popup-localization-country-dropdown');
        const iconSvg = popupCountryBtn.querySelector('svg.icon');
        const iconPath = iconSvg?.querySelector('path');

        if (popupCountryDropdown.style.visibility != "visible") {
          iconSvg.classList.remove(`icon-chevron-down`);
          iconSvg.classList.add(`icon-chevron-up`);
          iconPath.setAttribute('d', 'M6 15L12 9L18 15');

          let option = '<ul id="popup-localization-country-dropdown-menu" class="country-dropdown-nav">';

          window.availableCountries.forEach(item => {
            let name = item.name;
            let downcase_iso_code = item.downcase_iso_code;
            if (downcase_iso_code == "de") {
              name = "European Union";
              downcase_iso_code = "eu";
            }

            option += '<li>';
            option += '<p data-value="' + item.iso_code + "," + downcase_iso_code + "," + name + ' (' + item.currency_iso_code + item.currency_symbol + ')' + '"';
            if (popupCountryText.dataset.value == item.iso_code) {
              option += 'class="active pointer-events-none"';
            }
            option += '>'
            option += '<span class="fi fi-' + downcase_iso_code + '" style="margin-right: 8px;"></span>';
            option += name + ' (' + item.currency_iso_code + item.currency_symbol + ')';
            option += '</p>'
            option += '</li>';
          });
          option += '</ul>';

          popupCountryDropdown.innerHTML = '';
          popupCountryDropdown.innerHTML = option;
          const popupCountryDropdownMenu = document.getElementById('popup-localization-country-dropdown-menu');
          popupCountryDropdownMenu.addEventListener('click', (event) => {
            // 點擊可能落在旗幟 span 或 li 空白處，向上找帶 data-value 的選項
            const option = event.target.closest('p[data-value]');
            if (!option) return;
            const value = option.dataset.value;
            const split = value.split(",");
            const text = split[2];
            popupCountryText.dataset.value = split[0];
            popupCountryText.innerHTML = text;

            popupCountryFlag.classList.forEach(cls => {
              if (cls.startsWith('fi-') && cls !== 'fi') {
                popupCountryFlag.classList.remove(cls);
              }
            });
            popupCountryFlag.classList.add(`fi-${split[1]}`);

            iconSvg.classList.remove(`icon-chevron-up`);
            iconSvg.classList.add(`icon-chevron-down`);
            iconPath.setAttribute('d', 'M6 9L12 15L18 9');
            popupCountryDropdown.style.visibility = 'hidden';
          });

          popupCountryDropdown.style.visibility = 'visible';
        } else {
          iconSvg.classList.remove(`icon-chevron-up`);
          iconSvg.classList.add(`icon-chevron-down`);
          iconPath.setAttribute('d', 'M6 9L12 15L18 9');
          popupCountryDropdown.style.visibility = 'hidden';
        }
      }

      async changeLocalization() {
        const formData = new FormData();
        formData.append('form_type', 'localization');
        formData.append('utf8', '✓');
        formData.append('_method', 'put');
        formData.append('return_to', window.location.pathname);

        // const popupLanguageText = document.getElementById('popup-localization-language-text');
        // formData.append('locale_code', popupLanguageText.dataset.value);

        const popupCountryText = document.getElementById('popup-localization-country-text');
        formData.append('country_code', popupCountryText.dataset.value);

        const shopBtn = document.getElementById('popup-localization-shop-btn');
        if (shopBtn) shopBtn.disabled = true;

        try {
          const response = await fetch('/localization', {
            method: 'POST',
            body: formData
          });

          // 被重定向到 bot 驗證頁時切換並未生效：不能寫「已切換」標記；
          // 這是用戶主動點擊，直接帶去完成驗證（驗證後 Shopify 會回跳 return_to）
          // （精確比對 pathname，同 country-auto-switch，避免誤傷路徑含 challenge 字樣的頁面）
          if (response.redirected && response.url && new URL(response.url).pathname === '/challenge') {
            window.location.href = response.url;
            return;
          }

          if (response.ok || response.redirected) {
            // 手動選過國家後不再執行首次訪問自動切換（見 snippets/country-auto-switch.liquid）
            try { window.localStorage.setItem('country_auto_switch_done', '1'); } catch (error) {}
            window.location.reload();
            return;
          }

          // 429 等失敗：恢復按鈕可再點，不再看起來像失靈
          console.error('changeLocalization failed:', response.status);
          if (shopBtn) shopBtn.disabled = false;
        } catch (error) {
          console.error('changeLocalization error:', error);
          if (shopBtn) shopBtn.disabled = false;
        }
      }

      load(delay, force = false) {
        if (Shopify.designMode) return;

        // Re-check at fire time: country auto-switch may have resolved the
        // country (and set the expiry key) while this timer was pending.
        setTimeout(() => {
          if (force || this.testMode || this.isExpiry()) {
            this.showWhenStyled();
          }
        }, delay * 1000);
      }

      // Avoid showing the popup before its (async-loaded) stylesheet is applied,
      // which on slow networks produced an unstyled / broken layout flash.
      showWhenStyled() {
        const link = document.querySelector('link[href*="country-popup.css"]');

        // No managed stylesheet link (e.g. design mode injects it inline) — just show.
        if (!link) {
          this.show();
          return;
        }

        // Force the print-media (deferred) stylesheet to apply.
        if (link.media !== 'all') {
          link.media = 'all';
        }

        // Stylesheet already downloaded & parsed → safe to show immediately.
        if (link.sheet) {
          this.show();
          return;
        }

        // Otherwise wait for it to finish, with a fallback so it never gets stuck.
        let shown = false;
        const reveal = () => {
          if (shown) return;
          shown = true;
          this.show();
        };
        link.addEventListener('load', reveal, { once: true });
        setTimeout(reveal, 2000);
      }

      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
        this.setExpiry();
      }

      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');

        if (this.testMode) {
          this.removeExiry();
          return;
        }
      }

      isExpiry() {
        const timestamp = Date.now();
        const expiryTimestamp = window.localStorage.getItem('popoup_country_select_expiry');
        return timestamp > expiryTimestamp;
      }

      setExpiry() {
        const timestamp = Date.now();
        const expiryTimestamp = timestamp + (this.expiry * 24 * 60 * 60 * 1000);
        window.localStorage.setItem('popoup_country_select_expiry', expiryTimestamp);
      }

      removeExiry() {
        window.localStorage.setItem('popoup_country_select_expiry', 0);
      }
    }
  );
}
